import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import {payOrder} from '@/api/server/pay'
import {warning, success, error} from '@/utils/message'
import VueQr from 'vue-qr';
// import {orderPayStatus} from '@/api/server/order'
import {payWechatJsApi} from '@/api/server/pay'

export default {
  name: 'PayPage',
  mixins: [commonMixin],
  data () {
    return {
      _orderSn: null,
      qrcode: null,
      orderInfo: null,
      payStatus: false
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    VueQr
  },
  methods: {
    onMyOrder () {
      this.$router.push({name: 'user-order'})
    },
    // 获取支付相关信息
    _payWechatJsApi () {
      let query = {
        order_sn: this._orderSn
      }
      payWechatJsApi(query).then( res => {
        console.log('wechatJsApi', res)
        if (res.code === 200 && res.data) {
           // 拉起支付
           this.onBridgeReady(res.data)
        } else {
          warning(res.message)
          this.$router.push({path: '/user/order'})
        }
      })
    },
    // 拉起支付
    onBridgeReady(params) {
      var that = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', {
          "appId": params.appId,  //公众号名称，由商户传入
          "timeStamp": params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          "nonceStr": params.nonceStr,  //支付签名随机串，不长于 32 位
          "package": params.package,//统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          "signType": params.signType,  //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          "paySign": params.paySign, //支付签名
        },
        function (res) {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            success('支付成功！')
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            error('已取消支付')
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            error('支付失败！')
          } else {
            error('支付失败')
          }
          that.$router.push({path: '/user/order'})
        });
    },
    // 二维码支付调用
    getOrder () {
      let query = {
        order_sn: this._orderSn
      }
      payOrder(query).then( (res) => {
        if (res.code === 200 && res.data) {
          if (res.data.order) {
            this.orderInfo = res.data.order
          }
          if (res.data.qrcode) {
            if (res.data.qrcode.code_url) {
              this.qrcode = res.data.qrcode.code_url
            } else {
              this.qrcode = res.data.qrcode
            }
          }
        } else {
          warning(res.message)
          // this.$router.push({name: 'user-order'});
        }
      })
    },
    reset () {
      this.qrcode = null
      this.orderInfo = null
      this.payStatus = false
      // this.getOrder()
      this._payWechatJsApi()
      // this.timer = setInterval(() => {
      //   this._getOrderPayStatus()
      // }, 2500);
    },
    handleRoute (route) {
        if (route.name === 'pay') {
          this._orderSn = this.$route.query.order_sn
          this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  },
  created() {
  },
  beforeDestroy() {
  }
}